import type { SxProps, Theme } from "@mui/material/styles";

import { mergeSx } from "ui/merge-sx";

export const COLUMN_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  maxWidth: 400,
  position: "relative",
};

export const LOADING_OVERLAY_SX: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  minHeight: "100%",
};

/** Tailwind's `shadow` geometry tinted to `grey[100]`, as the legacy `shadow shadow-gray-100` drew it. */
const CARD_SHADOW_SX: SxProps<Theme> = (theme) => ({
  boxShadow: `0 1px 3px 0 ${theme.palette.grey[100]}, 0 1px 2px -1px ${theme.palette.grey[100]}`,
});

export const PREVIEW_SX: SxProps<Theme> = mergeSx(CARD_SHADOW_SX, { position: "relative" });

export const EMAIL_HEADER_SX: SxProps<Theme> = (theme) => ({
  px: 2,
  py: 1.5,
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.grey[200]}`,
  borderBottom: 0,
});

export const SUBJECT_LINE_SX: SxProps<Theme> = (theme) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.grey[600],
});

export const PREHEADER_SX: SxProps<Theme> = (theme) => ({
  mt: 0.5,
  fontWeight: theme.typography.fontWeightRegular,
  color: theme.palette.grey[500],
});

export const ERROR_SX: SxProps<Theme> = mergeSx(CARD_SHADOW_SX, (theme) => ({
  position: "relative",
  height: "100%",
  minHeight: 400,
  p: 3,
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.grey[200]}`,
}));

export const ERROR_CONTENT_SX: SxProps<Theme> = {
  position: "sticky",
  top: "50%",
  transform: "translateY(-50%)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  p: 2,
  textAlign: "center",
};

export const ERROR_MESSAGE_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
  color: theme.palette.error.main,
});

export const ERROR_HEADING_SX: SxProps<Theme> = (theme) => ({
  fontWeight: theme.typography.fontWeightMedium,
});

export const REWRITER_CHANGES_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
  mt: 2,
};

export const REWRITER_CHANGES_LABEL_SX: SxProps<Theme> = (theme) => ({
  fontWeight: 600,
  color: theme.palette.grey[900],
});

export const REWRITER_CHANGES_TEXT_SX: SxProps<Theme> = (theme) => ({
  color: theme.palette.grey[900],
});
